import { createReducer } from '@reduxjs/toolkit'
import { CompanySearchResult, Resource, Company } from 'shared/types'
import { initResource, setFailed, setPending, setSucceeded } from 'shared/utils'
import { config } from 'config'
import * as actions from './actions'

interface State {
  search: Resource<CompanySearchResult>
  accountantCompanies: Resource<Company[]>
  selectedCompanyId: string | null
}

const initialState: State = {
  search: initResource(),
  accountantCompanies: initResource([]),
  selectedCompanyId: localStorage.getItem(config.selectedAccountantCompanyKey),
}

export default createReducer(initialState, builder =>
  builder
    .addCase(actions.searchCompanies.pending, state => {
      setPending(state.search)
    })
    .addCase(actions.searchCompanies.fulfilled, (state, { payload }) => {
      setSucceeded(state.search, payload)
    })
    .addCase(actions.searchCompanies.rejected, state => {
      setFailed(state.search)
    })
    .addCase(actions.getAccountantCompanies.pending, state => {
      setPending(state.accountantCompanies)
    })
    .addCase(actions.getAccountantCompanies.fulfilled, (state, { payload }) => {
      setSucceeded(state.accountantCompanies, payload)
    })
    .addCase(actions.getAccountantCompanies.rejected, state => {
      setFailed(state.accountantCompanies)
    })
    .addCase(actions.selectCompanyId, (state, { payload }) => {
      const stringId = `${payload}`
      state.selectedCompanyId = stringId
      localStorage.setItem(config.selectedAccountantCompanyKey, stringId)
    })
    .addCase(actions.clearCompanySelection, state => {
      state.selectedCompanyId = null
      localStorage.removeItem(config.selectedAccountantCompanyKey)
    })
)
